import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  toolbar: {
  },
  appBar: {
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(3, 2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  button: {
    margin: theme.spacing(1),
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  grid: {
    height: 240,
    [theme.breakpoints.up('md')]: {
      width: 550,
    },
  },
  pFormControl: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  pFormControlPanel: {
    margin: `${theme.spacing(1)} 0`,
    width: '100%',
    boxSizing: 'border-box',
  },
  pForm_selectionBox: {
    maxHeight: 510,
    display: 'flex',
    flexWrap: 'wrap',
    width: 450,
    [theme.breakpoints.down('xl')]: {
      width: 450,
    },
    [theme.breakpoints.down('lg')]: {
      width: 450,
    },
    [theme.breakpoints.down('md')]: {
      width: 450,
    },
    [theme.breakpoints.down('sm')]: {
      width: 425,
    },
  },
  pForm_checkboxTree: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.up('md')]: {
    },
  },
  customerCard: {
    background: '#fff',
    width: '100%',
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    minHeight: 175,
  },
  customerCard_caption: {
    fontWeight: 'bold',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    alignContent: 'center',
  },
  customerCard_content: {
    fontWeight: 'normal',
    alignContent: 'left',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  searchField: {
    width: '75%',
    margin: '8px',
  },
  checkboxTreeContainer: {
    width: '100%',
    minHeight: 320,
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '10px',
  },
  provisionTreeContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    width: 800,
    [theme.breakpoints.down('xl')]: {
      width: 725,
    },
    [theme.breakpoints.down('lg')]: {
      width: 650,
    },
    [theme.breakpoints.down('md')]: {
      width: 550,
    },
    [theme.breakpoints.down('sm')]: {
      width: 425,
    },
    flexDirection: 'column',
    alignItems: 'center',
  },
  checkboxSubmit: {
    margin: theme.spacing(3, 0, 2),
    maxWidth: 250,
    minWidth: 190,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  list: {
    width: 250,
  },
  listItem: {
    paddingLeft: theme.spacing(4),
  },
  listItemPadding: {
    padding: theme.spacing(0, 0 , 0, .875),
  },
  listItemText: {
    '&&': {
      fontSize: '14px',
    }
  },
  fullList: {
    width: 'auto',
  },
  mb2: {
    marginBottom: theme.spacing(2)
  },
  noMP: {
    paddingBottom: 0,
    marginBottom: 0
  },
  smallFont: {
    fontSize: '8pt',
    padding: 0
  },
  ml1: {
    marginLeft: theme.spacing(1)
  },
  ml2: {
    marginLeft: theme.spacing(2)
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
});

export const getGenericStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  toolbar: {
  },
  appBar: {
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(3, 2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  titleBar: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '20px'
  },
  button: {
    margin: theme.spacing(1),
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  grid: {
    height: 240,
    [theme.breakpoints.up('md')]: {
      width: 550,
    },
  },
  pFormControl: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  pFormControlPanel: {
    margin: `${theme.spacing(1)} 0`,
    width: '100%',
    boxSizing: 'border-box',
  },
  pForm_selectionBox: {
    maxHeight: 510,
    display: 'flex',
    flexWrap: 'wrap',
    width: 450,
    [theme.breakpoints.down('xl')]: {
      width: 450,
    },
    [theme.breakpoints.down('lg')]: {
      width: 450,
    },
    [theme.breakpoints.down('md')]: {
      width: 450,
    },
    [theme.breakpoints.down('sm')]: {
      width: 425,
    },
  },
  pForm_checkboxTree: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.up('md')]: {
    },
  },
  pForm_paper: {
    width: '100%',
    padding: theme.spacing(3, 2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  stepContainer_header: {
    alignItems: 'center',
    fontFamily: 'Roboto',
    display: 'flex',
    gap: '8px',
    padding: '5px',
    paddingLeft: '15px',
    backgroundColor: '#DCDCDC',
  },
  infoIcon: {
    cursor: 'pointer'
  },
  customerCard: {
    background: '#fff',
    width: '80%',
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    minHeight: 175,
  },
  customerCard_caption: {
    fontWeight: 'bold',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    alignContent: 'center',
  },
  customerCard_content: {
    fontWeight: 'normal',
    alignContent: 'left',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  searchField: {
    width: '100%',
    margin: '8px',
  },
  checkboxTreeContainer: {
    width: '100%',
    minHeight: 320,
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '10px',
  },
  provisionTreeContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',
  },
  provisionContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    width: 800,
    [theme.breakpoints.down('xl')]: {
      width: 725,
    },
    [theme.breakpoints.down('lg')]: {
      width: 650,
    },
    [theme.breakpoints.down('md')]: {
      width: 550,
    },
    [theme.breakpoints.down('sm')]: {
      width: 425,
    },
    flexDirection: 'column',
    alignItems: 'center',
  },
  checkboxSubmit: {
    margin: theme.spacing(3, 0, 2),
    maxWidth: 250,
    minWidth: 190,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  mb2: {
    marginBottom: theme.spacing(2)
  },
  noMP: {
    paddingBottom: 0,
    marginBottom: 0
  },
});
